import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type ResendRecoveryCodeOperation = paths['/executor_web/recovery/resend']['post'];

export type ResendRecoveryCodeRequestBody = NonNullable<
	NonNullable<ResendRecoveryCodeOperation['requestBody']>['content']['application/json']
>;
export interface ResendRecoveryCodeRequest extends ResendRecoveryCodeRequestBody {
	token: string;
}
export type ResendRecoveryCodeResponse = ResendRecoveryCodeOperation['responses'][200]['content']['application/json'];
export type ResendRecoveryCodeErrorResponse =
	ResendRecoveryCodeOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/recovery/resend` — см. `paths['/executor_web/recovery/resend']` в auth swagger */
export function resendRecoveryCode(request: ResendRecoveryCodeRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<ResendRecoveryCodeResponse>('recovery/resend', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
